import Paper from '@mui/material/Paper'
import * as React from 'react'
import moment from 'moment'
import Table from '@mui/material/Table'
import { styled } from '@mui/material/styles'
import SaveIcon from '@mui/icons-material/Save'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'
import { useDispatch, useSelector } from 'react-redux'
import { getMonthlyTotal, getProrateTotal } from '../Summary/selectors'
import { ActionsDivComponent } from '../Register/Actions'
import { actions as registerActions } from '../Register/reducer'
import {
  createTransaction,
  createTransactionError,
} from '../Profile/commands/transactions/create'
import { getProfile } from '../Profile/selectors/api/profile'
import { getIsLoading } from '../App/selectors'
import { createSubscriptionError } from '../Profile/commands/subscriptions/create'
import { onError } from '../../utils/onError'

const PaperComponent = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey['900'],
}))

export const PaymentComponent: React.FC = () => {
  const dispatch = useDispatch()
  const nextMonth = moment()
    .add(1, 'months')
    .startOf('month')
    .format('MM-DD-YYYY')
  const monthlyTotal = useSelector(getMonthlyTotal)
  const prorateTotal = useSelector(getProrateTotal)
  const profile = useSelector(getProfile)
  const _createTransactionError = useSelector(createTransactionError)
  const _createSubscriptionError = useSelector(createSubscriptionError)
  const isLoading = useSelector(getIsLoading)

  const onActiveStep = React.useCallback(
    (step: number) => {
      dispatch(registerActions.onActiveStep(step))
    },
    [dispatch]
  )

  React.useEffect(() => {
    if (_createTransactionError) onError('Failed to create transaction')
    if (_createSubscriptionError) onError('Failed to create subscription')
  }, [_createTransactionError, _createSubscriptionError])

  const onSubmit = React.useCallback(() => {
    createTransaction(profile)
  }, [createTransaction, profile])

  return (
    <PaperComponent variant="outlined">
      <div />
      <Table size="small">
        <tbody>
          <tr>
            <td style={{ width: '100%', height: 50, textAlign: 'center' }}>
              First monthly payment of <b>${monthlyTotal}</b> will start on{' '}
              <b>{nextMonth}</b>
            </td>
          </tr>
          <tr>
            <td style={{ width: '100%', height: 50, textAlign: 'center' }}>
              Todays one time prorated payment amount <b>${prorateTotal}</b>
            </td>
          </tr>
        </tbody>
      </Table>
      <div />
      <ActionsDivComponent
        onActionLeft={() => onActiveStep(4)}
        leftIcon={<NavigateBeforeIcon />}
        textLeft="Previous"
        colorLeft="inherit"
        leftVariant="outlined"
        onActionRight={onSubmit}
        rightIcon={<SaveIcon />}
        textRight="Submit"
        colorRight="success"
        rightVariant="contained"
        disabledLeft={isLoading}
        disabledRight={isLoading}
      />
    </PaperComponent>
  )
}
